import * as React from 'react';
import {
  MasonryEngineNode,
  MasonryEngineNodeRendererProps,
} from '@leagueplatform/masonry-engine';
import {
  Box,
  GDSColorToken,
  colorTokenMap,
} from '@leagueplatform/genesis-core';
import { MaxWidthWrapper } from '@leagueplatform/web-common-components';

export const NODE_TYPE_MEMBER_DROPDOWN_CONTAINER = 'memberDropdownContainer';

type MemberDropdownContainerProps = {
  backgroundColor: GDSColorToken;
};

type MemberDropdownContainerNode = MasonryEngineNode<
  typeof NODE_TYPE_MEMBER_DROPDOWN_CONTAINER,
  MemberDropdownContainerProps,
  {},
  {
    items: MasonryEngineNode<string, any>[];
  }
>;

export type MemberDropdownContainerRendererProps =
  MasonryEngineNodeRendererProps<MemberDropdownContainerNode>;

export function MemberDropdownContainer({
  items,
  backgroundColor: colorToken = 'surfaceCardPrimary',
}: MemberDropdownContainerRendererProps) {
  if (!items || !items.length) return null;
  const backgroundColor = colorTokenMap[colorToken] ?? colorToken;

  return (
    <Box
      css={{
        padding: '$three $none',
        position: 'relative',
        '&::before': {
          content: '""',
          position: 'absolute',
          top: 0,
          left: `calc(-50vw + 50%)`,
          right: `calc(-50vw + 50%)`,
          width: '100vw',
          height: '100%',
          backgroundColor,
          zIndex: -1,
        },
        '@mobile': {
          padding: '$two $none',
        },
      }}
    >
      <MaxWidthWrapper
        css={{
          display: 'grid',
          gridTemplateColumns: '1fr 1fr 1fr',
          '@mobile': {
            gridTemplateColumns: '1fr',
          },
        }}
      >
        {items}
      </MaxWidthWrapper>
    </Box>
  );
}
